import "./EdocsHomePage.css"
import BottomBar from "../BottomBar/bottombar"
import {
  info,
  arrowDownRight,
  arrowTopRight,
  successThumb,
  pdfIcon
} from "../../images"
import { useState, useEffect } from "react"
import { apiEndPoints } from "constants/apiEndpoints"
import { getYardData } from "../../utils/yards"
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "store/store"
import { http } from "utils/http"
import { useHistory } from "react-router-dom"
import SMSTimer from "./SMSTimer"
import { useTranslation } from "react-i18next"

var refreshPage = false
const EdocsHomePage = () => {
  const { t } = useTranslation()
  const history: any = useHistory()
  const locationData = history.location.state?.data || ""
  const dispatch = useDispatch()

  const appointmentDetails = useSelector(
    (state: RootState) => state.appointmentReducer.appointment?.details
  )
  const matchingVisitDetails = useSelector(
    (state: RootState) =>
      state.appointmentReducer.appointment?.matchingVisitDetails
  )

  const visitObj = useSelector(
    (state: RootState) => state.visitReducer.visit?.visit
  )
  const edocsObj = useSelector(
    (state: RootState) => state.edocsReducer.edocs[0]?.edocs
  )
  const isResendVisible = useSelector(
    (state: RootState) => state.edocsReducer.isResendVisible
  )

  const direction_fetch = useSelector(
    (state: RootState) => state.directionReducer
  )
  const visitId = matchingVisitDetails?.id || visitObj?.visit?.id

  const gateModule = visitObj.facility.configuration.modules.filter(
    (item: any) => {
      return item.name == "gate"
    }
  )
  const initActivityType = async (activityType: string, callback: any) => {
    await http
      .post(
        `${apiEndPoints.activities}${visitId}/activities`,
        {
          type: activityType
        },
        {}
      )
      .then(() => true)
      .catch(() => true)
    callback()
  }
  const isEdocSuccess = (item: any) => {
    let status = false
    if (Array.isArray(item)) {
      item.map((item: any) => {
        if (item.itemKey != "Bob-Tail") {
          status = item.isCompleted ? true : false
          if (item.isCompleted) {
            initActivityType(
              item.headerText === "Inbound"
                ? "edocs-pod-completed"
                : "edocs-pop-completed",
              () => true
            )
          }
        }
      })
    }

    return status
  }
  let yardData: any = []

  const IsEdocssuccess = isEdocSuccess(edocsObj?.yardSections)
  const [edocSuccess, setEdocSuccess] = useState(IsEdocssuccess)
  let urlParams: any = new URLSearchParams(window.location.search)
  let modename: string = urlParams.get("force_refresh")
  const setData = (YardDatadetails: any, IsEdocssuccess: boolean) => {
    YardDatadetails.edocSuccess = IsEdocssuccess
    setEdocSuccess(IsEdocssuccess)
    dispatch({
      type: "SET_EDOCS",
      payload: [
        {
          edocs: YardDatadetails
        }
      ]
    })
  }
  const fetchYard = () => {
    http
      .post(
        `${apiEndPoints.fetchYard}`,
        {
          visitId: visitId
        },
        {}
      )
      .then(res => {
        const yardData = res.data.data
        http
          .post(
            `${apiEndPoints.fetchEdocs}`,
            {
              visitId: visitId
            },
            {}
          )
          .then(res => {
            const YardDatadetails: any = getYardData(yardData, res?.data?.data)
            let IsEdocssuccess = isEdocSuccess(YardDatadetails?.yardSections)
            YardDatadetails.edocSuccess = IsEdocssuccess
            setData(YardDatadetails, IsEdocssuccess)
          })
          .catch(err => {
            if (err.response?.status === 404) {
              const YardDatadetails: any = getYardData(yardData, null)
              let IsEdocssuccess = isEdocSuccess(YardDatadetails?.yardSections)
              YardDatadetails.edocSuccess = IsEdocssuccess
              setData(YardDatadetails, IsEdocssuccess)
            }
          })
      })
      .catch(err => {
        if (err.response?.status === 404) {
          const YardDatadetails: any = getYardData(null, null)
          let IsEdocssuccess = isEdocSuccess(YardDatadetails?.yardSections)
          YardDatadetails.edocSuccess = IsEdocssuccess
          setData(YardDatadetails, IsEdocssuccess)
        }
      })
  }

  const initiateAction = (item: any, isCompleted: any) => {
    let activityType: string =
      item.headerText === "Inbound"
        ? "edocs-pod-initiated"
        : "edocs-pop-initiated"

    if (isCompleted === "viewedoc") {
      initActivityType(activityType, () => {
        window.location.href = item.edocsUrl
      })
    } else {
      initActivityType(activityType, () => {
        window.open(item.documentUrl)
      })
    }
  }

  const initiateProcess = () => {
    http
      .post(
        `${apiEndPoints.fetchDirection}`,
        {
          visitId: visitId,
          direction: "outbound"
        },
        {}
      )
      .then(response => {
        dispatch({
          type: "SET_DIRECTION",
          payload: [
            {
              direction: response.data.data
            }
          ]
        })
        history.push("/checkout")
      })
  }

  useEffect(() => {
    if (refreshPage == false) {
      fetchYard()
      refreshPage = true
    }
    if (!isResendVisible) {
      const timeOut = setTimeout(() => {
        dispatch({
          type: "SET_RESENDSMS",
          payload: [
            {
              isResendVisible: true
            }
          ]
        })
      }, 30000)
      return () => clearTimeout(timeOut)
    }
  })

  return (
    <>
      {refreshPage && (
        <>
          <div className={`container edoc-container`}>
            {edocsObj?.edocSuccess &&
              renderEdocSuccessPage({ isResendVisible }, t)}
            {!edocsObj?.edocSuccess && edocsObj?.showBannerText && (
              <div className="warning-info" style={{ marginTop: "16px" }}>
                <img
                  className="warning-info-img"
                  src={info}
                  alt="edocks-home-page"
                />
                <div className="warning-info-text">
                  {t("edoc_load_enabled")}
                </div>
              </div>
            )}
            {Array.isArray(edocsObj?.yardSections) &&
              edocsObj?.yardSections.map((item: any, index: number) => {
                return (
                  <div className="accord-container">
                    <div className="accord-header">
                      <img
                        className="accord-header-image"
                        src={
                          item.headerText === "Inbound"
                            ? arrowDownRight
                            : arrowTopRight
                        }
                        alt="arrowIcon"
                      />
                      <div className="accord-header-text">
                        {t(item.headerText)}
                      </div>
                    </div>
                    <div className="accord-items">
                      <div className="accord-item-key">
                        {item.itemKey}{" "}
                        <span className="accord-item-span">
                          {item.itemKeySpan}
                        </span>
                      </div>
                      <div className="accord-item-value">{item.itemValue}</div>
                    </div>
                    <div className="accord-button">
                      {!item.showUnavailableText && (
                        <BottomBar
                          className={item.isCompleted ? "whiteBorderedBtn" : ""}
                          onClick={(event: any) => {
                            initiateAction(
                              item,
                              item.isCompleted ? "pdf" : "viewedoc"
                            )
                          }}
                          buttonDisplay={!item.isButtonVisible}
                          disabled={!item.isButtonEnabled}
                          text={t(item.buttonText)}
                          endIcon={
                            !item.isCompleted ? (
                              <KeyboardArrowRightIcon />
                            ) : null
                          }
                          startIcon={
                            item.isCompleted ? (
                              <img src={pdfIcon} alt="pdfIcon" />
                            ) : null
                          }
                        />
                      )}
                      {item.showUnavailableText && (
                        <div className="accord-item-Unavailable">
                          {item.unavailabletext}
                        </div>
                      )}
                    </div>
                    {!item.showUnavailableText &&
                      item.isCompleted &&
                      item.edocsUrl !== "" && (
                        <div className="no-ref-help">
                          {/* eslint-disable-next-line */}
                          <a
                            className="no-ref-help-text"
                            onClick={() => initiateAction(item, "viewedoc")}
                          >
                            <span>{t("view_edocs_details")}</span>
                            <KeyboardArrowRightIcon className="vert-middle" />
                          </a>
                        </div>
                      )}
                    <div className="accord-items-footer">{item.footerText}</div>
                  </div>
                )
              })}
          </div>
          <BottomBar
            disabled={!edocsObj?.edocSuccess}
            buttonDisplay={gateModule.length == 0}
            onClick={() => initiateProcess()}
            text={t("proceed")}
            endIcon={<KeyboardArrowRightIcon />}
          />
        </>
      )}
    </>
  )
}

export default EdocsHomePage
interface myProps {
  isResendVisible: boolean
}
const renderEdocSuccessPage = (props: myProps, t: Function) => {
  const time = new Date()
  time.setSeconds(time.getSeconds() + 30)

  return (
    <>
      <div className="edoc-success">
        <div className="edoc-success-text">{t("edoc_completed_process")}</div>
        <img
          className="edoc-success-img"
          src={successThumb}
          alt="success-thumb"
        />
      </div>
      <div>{t("view_document_by_clicking")}</div>
      <div
        className="accord-container"
        style={{ paddingBottom: "0px", marginTop: "0px" }}
      >
        <div className="accord-button">
          <SMSTimer expiryTimestamp={time} />
        </div>
      </div>
    </>
  )
}
